<template>
  <div id="app">
    <div class="tel">
      <div><img width="180px" src="./assets/tel.png"/></div>
      </div>
    <div>
      <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="6"><div class="grid-content bg-purple">
        <img width="100%" src="./assets/logo.png"/>
      </div></el-col>
      <el-col :span="6"><div class="grid-content bg-purple-light"></div></el-col>
      <el-col :span="6"><div class="grid-content bg-purple">
        <img src="./assets/phone.png"/>
      </div></el-col>
    </el-row>
    <el-menu :default-active="activeIndex" class="el-menu-demo" background-color="#175fa4"
                 text-color="white" active-text-color="white"
                 mode="horizontal" @default-active="this.$route.path" 
                 @select="handleSelect" :router=true>
          <el-menu-item style="font-size: 20px; font-weight: bold"
           v-for="(item, i) in navList" :key="i" :index="item.name">{{item.navItem}}</el-menu-item>
        </el-menu>
    </div>
    
    <el-carousel :interval="4000" type="card" height="380px">
    <el-carousel-item v-for="item in fenms" :key="item.name">
      <img class="medium" width="100%" :src="item.src"/>
    </el-carousel-item>
  </el-carousel>
  <router-view/>
   <el-footer height="300px">
      <div>
        <div>
          <div  style="float:left;">
            <h2 class="biaoti" style="line-height: 60px; font-size: 25px;">绍兴上虞三源通风设备有限公司</h2>
            <h4 class="biaoti">联系我们 CONTACT US</h4>
            <h5 class="biaoti">张先生 / 13819534097 / 吴先生 / 13587384022 / 浙江省绍兴市上虞区上浦镇104国道东侧</h5>
            <h5 class="biaoti">三源通风专业生产风机，消防风机，屋顶风机，离心风机，轴流风机等各类风机及配件</h5>
          </div>
          <div style="text-align: right; padding-top: 30px; padding-right: 50px">
            <img width="110px" src="./assets/icon.png"/>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="biaoti">
          <el-link type="info" href="https://beian.miit.gov.cn/#/Integrated/index">备案号：浙ICP备16028295号-1</el-link>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: "Shouye",
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      navList:[
        {name:'/Shouye',navItem:'首页'},
        {name:'/Chanpin',navItem:'产品中心'},
        {name:'/Zhengshu',navItem:'资质证书'},
        {name:'/Anli',navItem:'成功案例'},
        {name:'/Lianxi',navItem:'联系我们'} 
      ],
      fenms:[
        {
        name: 1,
        src: require("@/assets/fengmian/damen.png")
        },
        {
        name: 2,
        src: require("@/assets/fengmian/xuanchuan.png")
        },
        {
        name: 3,
        src: require("@/assets/fengmian/xuanchuan2.png")
        }
        ]
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath, this.$route.path);
    }
  }
}

</script>

<style>
 #app {
   margin-left: auto;
   margin-right: auto;
   width: 1450px;
   height: auto;
 }
 
 .tel {
   position: fixed;
   right: 4%;
   bottom: 15%;
 }

 .el-header, .el-footer {
  background-color: #175fa4;
  color: #333;
  text-align: center;
  line-height: 60px;
}

 .biaoti {
  text-align: left;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.99);
  line-height: 20px;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
